<template>
  <div>
    <p class="tips">{{ $t('tips.cash_out_setting_detail') }}</p>
    <el-descriptions class="margin-top" :column="1" label-class-name="cash-label">
      <el-descriptions-item :label="$t('system.withdraw_type')">
        <div style="display:flex;align-items: center">
          {{ withdrawTypeMapLabel(withdrawInfo.withdraw_type) }}
          <svg-icon class-name="icon-function" style="width:15px;margin:0;margin-left: 20px;" icon-class="operation-edit" @click="edit" />
        </div>
      </el-descriptions-item>
      <template v-if="withdrawInfo.withdraw_type === WITHDRAW_TYPE['automatic']">
        <el-descriptions-item :label="$t('merchant.withdrawal_account')">{{ `${bankInfo.settlement_bank}(${bankInfo.settlement_bank_account_num})` }}</el-descriptions-item>
        <el-descriptions-item :label="$t('system.auto_withdraw_type')">{{ autoWithdrawTypeMapLabel(withdrawInfo.auto_withdraw_type) }}</el-descriptions-item>
        <template v-if="withdrawInfo.auto_withdraw_type === AUTO_WITHDRAW_TYPE['period']">
          <el-descriptions-item :label="$t('data.withdrawal_period')">D+{{ withdrawInfo.auto_withdraw_dates }}</el-descriptions-item>
          <el-descriptions-item :label="$t('data.next_cash_out_date')">{{ withdrawInfo.auto_withdraw_next_date }}</el-descriptions-item>
          <el-descriptions-item v-if="isCurCountryID" :label="$t('data.minimum_cash_out_amount')">
            {{ withdrawInfo.withdraw_threshold | toDivideWithDot }} <span style="font-size: 10px;">( {{ $t('tips.automatic_withdrawal_amount_limit_1') }}{{ withdrawInfo.withdraw_threshold | toDivideWithDot }}{{ $t('tips.automatic_withdrawal_amount_limit_2') }} )</span>
          </el-descriptions-item>

        </template>
        <template v-else>
          <el-descriptions-item :label="$t('data.fixed_amount')">{{ withdrawInfo.auto_withdraw_amount }}</el-descriptions-item>
        </template>
      </template>
      <!-- <el-descriptions-item label="备注">
            <el-tag size="small">学校</el-tag>
          </el-descriptions-item> -->
      <el-descriptions-item v-if="withdraw_fee_status === 1" :label="$t('system.handling_fee')">{{ withdraw_fee | toDivideWithDot }} {{ $t('system.per_transaction') }}</el-descriptions-item>
    </el-descriptions>
    <ModifyWithdrawMethodModal ref="modifyWithdrawMethodModal" @changeComponent="changeComponent" @submit="getInfo" />
  </div>
</template>

<script>
import { fetchSettlementBank, fetchWithdrawType, fetchNeedSupplementStatus, fetchWithdrawFee } from '@/api/system/system.js'
import { withdrawTypeMap, autoWithdrawTypeMap } from '@/utils/maps'

export default {
  name: 'Cash_Out_Setting',
  components: {
    ModifyWithdrawMethodModal: () => import('./Modal/ModifyWithdrawMethodModal.vue')
  },
  data() {
    this.AUTO_WITHDRAW_TYPE = {
      period: 1,
      fixedAmount: 2
    }
    this.WITHDRAW_TYPE = {
      manually: 1,
      automatic: 2
    }
    return {
      activeName: 'Payment_Needs_Validation',
      isNeedSupplementStatus: false,
      withdrawInfo: {},
      bankInfo: {},
      withdraw_fee: null,
      withdraw_fee_status: null
    }
  },
  computed: {
    isCurCountryID() {
      return this.$store.getters.curCountry.country_code === 'ID'
    },
    withdrawTypeMapLabel() {
      return function(value) {
        return withdrawTypeMap(value).label
      }
    },
    autoWithdrawTypeMapLabel() {
      return function(value) {
        return autoWithdrawTypeMap(value).label
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      // this.getNeedSupplementStatus()
      this.getWithdrawType()
      this.getMchDetail()
      this.getWithdrawFee()
    },
    getWithdrawFee() {
      fetchWithdrawFee().then(res => {
        const { withdraw_fee, withdraw_fee_status } = res.data
        this.withdraw_fee = withdraw_fee
        this.withdraw_fee_status = withdraw_fee_status
        this.$forceUpdate()
      })
    },
    getNeedSupplementStatus() {
      return new Promise((resolve, reject) => {
        fetchNeedSupplementStatus().then(res => {
          const { data } = res
          this.isNeedSupplementStatus = data
          if (data) {
            this.$message.warning('Supplementary information is not passed!')
          }
          resolve(data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { data } = res
        if (data) {
          const { auto_withdraw_amount } = data
          if (auto_withdraw_amount) {
            this.withdrawInfo = { ...data, auto_withdraw_amount: auto_withdraw_amount / 100 }
          } else {
            this.withdrawInfo = data
          }
        }
      })
    },
    getMchDetail() {
      fetchSettlementBank().then(res => {
        if (res.data) {
          this.bankInfo = res.data[0] || {}
        }
      })
    },
    async edit() {
      // if (this.isNeedSupplementStatus) {
      //   this.$message.warning('Supplementary information is not passed!')
      //   return
      // }
      // await this.getNeedSupplementStatus()
      const params = {
        status: true,
        data: JSON.parse(JSON.stringify({ ...this.withdrawInfo, bank_no: this.bankInfo?.bank_no }))
      }
      this.$refs.modifyWithdrawMethodModal.changeModalStatus(params)
    },
    changeComponent(obj) {
      this.$emit('changeComponent', obj)
    }
  }
}
</script>

  <style lang="scss" scoped>
   .tips {
    color: #7A869E;
    font-size: 14px;
   }
   .el-descriptions {
    ::v-deep.cash-label {
      width: 240px;
      color: #98A1B4;
      font-size: 16px;
    }
    ::v-deep.el-descriptions-item__container {
      margin: 15px 0;
    }
   }

  </style>
